import { Component, OnInit, computed, inject } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { PlayerService } from "app/features/player/data-access/player.service";
import { IChannel, IEpg, LivePlayService, LiveStore } from "@features/live";
import { elapsedPercent } from "@features/live/utils/live-time.utils";
import { ClockService } from "@shared/utils";

interface IPlayerChannelItem {
    channel: IChannel;
    currentEpg: IEpg | null;
    elapsedPercentage: number;
}

@Component({
    selector: 'player-channels',
    templateUrl: './player-channels.component.html',
    styleUrls: ['./player-channels.component.scss'],
    imports: [
        CommonModule,
        DatePipe
    ]
})
export class PlayerChannelsComponent implements OnInit {
    private playerService = inject(PlayerService);
    private liveStore = inject(LiveStore);
    private livePlay = inject(LivePlayService);
    private clock = inject(ClockService);
    private item = this.playerService.getItem();

    // Follows the shared clock so the timelines advance while the list stays open (AVIION-37380).
    public items = computed<IPlayerChannelItem[]>(() => {
        const now = this.clock.now();
        return this.liveStore.channels().filter(c => !c.isAudio).map(c => {
            const currentEpg = this.liveStore.liveOf(c.referenceId);
            return {
                channel: c,
                currentEpg,
                elapsedPercentage: elapsedPercent(currentEpg, now),
            };
        });
    });

    ngOnInit(): void {
        this.liveStore.loadCurrentEpgs();
    }

    public changeChannel(item: IPlayerChannelItem): void {
        this.livePlay.playChannel(item.channel, item.currentEpg);
    }

    public isChannelSelected(channelReferenceId: string): boolean {
        return this.item()?.channelReferenceId == channelReferenceId;
    }
}
